"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable implicit-arrow-linebreak */

/**
 * Schema for an Author User
 * @param {ObjectId} objectIdType ObjectId type from mongoose package
 * @returns Array with Collection name and defined Schema
 */
var User = function User(objectIdType) {
  if (!objectIdType) {
    throw new Error('objectIdType must be provided');
  }
  return ['User', {
    email: {
      type: String,
      unique: true,
      validate: [{
        validator: /^[a-zA-Z0-9._%+-]+@praktio.com$/i,
        msg: 'A valid Praktio email address is required'
      }],
      required: true
    },
    created: {
      type: Date,
      "default": Date.now
    },
    updated: {
      type: Date,
      "default": Date.now
    },
    lastlogin: {
      type: Date
    },
    name: {
      type: String
    },
    isAdmin: {
      type: Boolean,
      "default": false
    },
    isLockedLearner: {
      type: Boolean
    },
    access: [{
      id: {
        type: objectIdType,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      canWrite: {
        type: Boolean,
        "default": false
      }
    }]
  }];
};
var _default = User;
exports["default"] = _default;